import { render, staticRenderFns } from "./PromptEditorModal.vue?vue&type=template&id=631e9f01&scoped=true"
import script from "./PromptEditorModal.vue?vue&type=script&lang=ts"
export * from "./PromptEditorModal.vue?vue&type=script&lang=ts"
import style0 from "./PromptEditorModal.vue?vue&type=style&index=0&id=631e9f01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631e9f01",
  null
  
)

export default component.exports